import { formatEuro, formatEuroExact, formatInteger } from '@brimo/shared';
import type { ControllingFigures } from './api';
import styles from './figures.module.css';

/** „Kampagnen" (Controlling 04): Name | Leads | Termine | Kosten | Kosten je Termin, „—" where the API has no value. */

const DASH = '—';

function NumberCell({ label, value }: { label: string; value: string }) {
  return (
    <span className={`${styles.cell} ${styles.cellNumber}`} role="cell">
      <span className={styles.cellKey}>{label}</span>
      <span>{value}</span>
    </span>
  );
}

export function CampaignsTable({ rows }: { rows: ControllingFigures['campaigns'] }) {
  return (
    <section className={`${styles.card} ${styles.tableCard}`} aria-labelledby="figures-campaigns-title">
      <h2 id="figures-campaigns-title" className={styles.cardTitle}>
        Kampagnen
      </h2>
      <div className={styles.table} role="table" aria-labelledby="figures-campaigns-title">
        <div className={`${styles.tableRow} ${styles.tableHead}`} role="row">
          <span className={styles.cell} role="columnheader">
            Kampagne
          </span>
          <span className={`${styles.cell} ${styles.cellNumber}`} role="columnheader">
            Leads
          </span>
          <span className={`${styles.cell} ${styles.cellNumber}`} role="columnheader">
            Termine
          </span>
          <span className={`${styles.cell} ${styles.cellNumber}`} role="columnheader">
            Kosten
          </span>
          <span className={`${styles.cell} ${styles.cellNumber}`} role="columnheader">
            Kosten je Termin
          </span>
        </div>
        {rows.length === 0 ? (
          <div className={styles.tableEmpty} role="row">
            <span role="cell">Keine Leads in diesem Zeitraum.</span>
          </div>
        ) : null}
        {rows.map((row) => (
          <div key={row.name} className={styles.tableRow} role="row">
            <span className={`${styles.cell} ${styles.cellName}`} role="cell">
              {row.name}
            </span>
            <NumberCell label="Leads" value={formatInteger(row.leads)} />
            <NumberCell label="Termine" value={formatInteger(row.appointments)} />
            <NumberCell label="Kosten" value={row.costCents === null ? DASH : formatEuro(row.costCents)} />
            <NumberCell
              label="Kosten je Termin"
              value={
                row.costPerAppointmentCents === null ? DASH : formatEuroExact(row.costPerAppointmentCents)
              }
            />
          </div>
        ))}
      </div>
    </section>
  );
}
